import React, { Fragment, useRef, Profiler } from "react";
import { StyleSheet, View } from "react-native";
import * as yup from "yup";
import { Formik } from "formik";
import useNavigationParam from "lib/use-navigation-param";
import useCustomBack from "lib/use-custom-back";
import SubmitErrorHandler from "lib/on-submit-error-handler";
import { TextInput, Scaffold } from "components";
import { useNavigation } from "@react-navigation/native";
import { buyerRoutes } from "lib/routing/routes";
import { createOrUpdatePurchaseOrder } from "./utils";
import fixNull from "lib/fix-null";
import DateInput from "components/TextInput/DateInput.web";
import Space from "components/Space/Space";

export default function PurchaseOrderDateOfShipment() {
  const id = useNavigationParam("id");
  const buyerId = useNavigationParam("buyerId");
  const shippingDate = useNavigationParam("shippingDate") || "";
  const customBack = useCustomBack();
  const isSubmitting = useRef(false);
  const navigation = useNavigation();

  return (
    <Scaffold>
      <Formik
        validationSchema={validatorSchema}
        initialValues={{
          shippingDate: fixNull(shippingDate),
        }}
        onSubmit={async (values) => {
          if (isSubmitting.current === false) {
            isSubmitting.current = true;
            const purchaseOrder = await createOrUpdatePurchaseOrder(buyerId, {
              id,
              ...values,
            });
            isSubmitting.current = false;

            return navigation.navigate(buyerRoutes.editPurchaseOrder, {
              ...purchaseOrder,
              buyerId: purchaseOrder.buyer?.id,
            });
          }
        }}
      >
        {({ submitForm }) => {
          customBack(submitForm);
          return (
            <Fragment>
              <DateInput name="shippingDate" placeholder="MM / DD / YYYY" />
              <Space />
              <TextInput
                name="shippingId"
                placeholder="Shipping ID"
                multiline={false}
              />
              <Space />
              <TextInput
                name="shipperName"
                placeholder="Shipper Name"
                multiline={false}
              />
              <SubmitErrorHandler />
            </Fragment>
          );
        }}
      </Formik>
    </Scaffold>
  );
}

const validatorSchema = yup.object().shape({
  shippingDate: yup.string().nullable(),
  shippingId: yup.string().nullable(),
  shipperName: yup.string().nullable(),
});
